import { queryKeys } from '@query/keys'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import type { DxTradeInstrumentDetailsResponseItem } from '@model/DxTrade.types'

export const useDxtradeInstrumentDetails = (
  accountCode?: string,
  symbol?: string | null
): {
  instruments?: DxTradeInstrumentDetailsResponseItem[]
  isLoading: boolean
  forceRefresh: (skipLoadingFlag?: boolean) => void
} => {
  const apiClient = useApiClient(ClientApiClient)
  const queryClient = useQueryClient()

  const { data, isLoading } = useQuery({
    queryKey: queryKeys.trade.dxtrade.instrumentDetails(accountCode, symbol),
    queryFn: () => apiClient.getDxtradeInstrumentDetails(accountCode!, symbol!),
    enabled: !!accountCode && !!symbol,
  })

  const forceRefresh = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.trade.dxtrade.instrumentDetails(accountCode, symbol),
    })
  }, [queryClient, accountCode, symbol])

  return {
    instruments: data,
    isLoading,
    forceRefresh,
  }
}
